import axiosInstance from '../axiosInstance';

/**
 * 2days 파일럿 신청 (비로그인 허용).
 * 같은 이메일로 이미 신청했으면 409 — 호출하는 쪽에서 안내 문구를 보여 준다.
 */
export const submitPilotApplication = async (payload) => {
  const response = await axiosInstance.post('/two-days/pilot-applications', payload, {
    skipAuthRefresh: true,
  });
  return response.data;
};
